const MobileIcon = (props) => {
    return (
        <svg
          width={25}
          height={25}
          viewBox="0 0 200 200"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <circle cx={100} cy={100} r={100} fill="#6E0202" fillOpacity={0.2} />
          <path
            d="M125.415 180s14.523 0 14.523-14.545V34.545C139.938 20 125.415 20 125.415 20h-50.83s-14.523 0-14.523 14.545v130.91C60.062 180 74.585 180 74.585 180h50.83zM100 173.944a7.264 7.264 0 01-7.261-7.262 7.264 7.264 0 017.261-7.261 7.263 7.263 0 017.261 7.261 7.263 7.263 0 01-7.261 7.262zM89.108 28.866c0-.9.428-1.605.965-1.605h19.853c.53 0 .966.72.966 1.605v.429c0 .9-.436 1.605-.966 1.605H90.073c-.53 0-.965-.72-.965-1.605v-.429zm-21.785 9.288h65.354v116.184H67.323V38.154z"
            fill="#6E0202"
          />
        </svg>
      )
    }
    
export default MobileIcon